import { ReWeighingDto } from "./re-weighment.dto";

export class ReWeighingItemsDto {
    rmItemWeighData: ReWeighingDto[];
}